// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ObjectNoResponse,
    ProviderFaxSortType,
    ProviderReceiveFax,
    ProviderSendFax,
    SupportAssignFaxPayload,
    SupportCreateFaxPayload,
    SupportFaxSortType,
    SupportReceiveFax,
    SupportSendFax,
    TemporaryDocumentUrl,
    SupportAssignFaxPayloadToJSON,
    SupportCreateFaxPayloadToJSON,
    ObjectNoResponseFromJSON,
    ProviderReceiveFaxFromJSON,
    ProviderSendFaxFromJSON,
    SupportReceiveFaxFromJSON,
    SupportSendFaxFromJSON,
    TemporaryDocumentUrlFromJSON,
} from '../models';

export interface AssignSupportReceiveFaxRequest {
    id: string;
    supportAssignFaxPayload: SupportAssignFaxPayload;
}

export interface CreateSupportSendFaxRequest {
    supportCreateFaxPayload: SupportCreateFaxPayload;
}

export interface GetProviderReceiveFaxRequest {
    id: string;
}

export interface GetProviderSendFaxRequest {
    id: string;
}

export interface GetSupportReceiveFaxRequest {
    id: string;
}

export interface GetSupportSendFaxRequest {
    id: string;
}

export interface ListProviderReceiveFaxesRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderReceiveFaxesOrderEnum>;
    filterCreated?: Array<string>;
    filterClaimId?: Array<string>;
    filterDocumentId?: Array<string>;
    filterExternalId?: Array<string>;
    filterOcr?: Array<string>;
    filterPages?: Array<string>;
    sort?: Array<ProviderFaxSortType>;
}

export interface ListProviderSendFaxesRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderSendFaxesOrderEnum>;
    filterCreated?: Array<string>;
    filterClaimId?: Array<string>;
    filterDocumentId?: Array<string>;
    filterExternalId?: Array<string>;
    sort?: Array<ProviderFaxSortType>;
}

export interface ListSupportReceiveFaxesRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportReceiveFaxesOrderEnum>;
    filterCreated?: Array<string>;
    filterClaimId?: Array<string>;
    filterDocumentId?: Array<string>;
    filterExternalId?: Array<string>;
    filterAssigned?: Array<string>;
    filterOcr?: Array<string>;
    filterPages?: Array<string>;
    filterTag?: Array<string>;
    sort?: Array<SupportFaxSortType>;
}

export interface ListSupportSendFaxesRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportSendFaxesOrderEnum>;
    filterCreated?: Array<string>;
    filterClaimId?: Array<string>;
    filterDocumentId?: Array<string>;
    filterExternalId?: Array<string>;
    filterTag?: Array<string>;
    sort?: Array<SupportFaxSortType>;
}

export interface UnassignSupportReceiveFaxRequest {
    id: string;
}

export interface ViewProviderSendFaxRequest {
    id: string;
}

export interface ViewSupportSendFaxRequest {
    id: string;
}

/**
 * no description
 */
export class FaxApi extends runtime.BaseAPI {

    /**
     * Assigns the received fax
     * Assigns the received fax
     */
    async assignSupportReceiveFaxRaw(requestParameters: AssignSupportReceiveFaxRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling assignSupportReceiveFax.');
        }

        if (requestParameters['supportAssignFaxPayload'] === null || requestParameters['supportAssignFaxPayload'] === undefined) {
            throw new runtime.RequiredError('supportAssignFaxPayload','Required parameter requestParameters.supportAssignFaxPayload was null or undefined when calling assignSupportReceiveFax.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:fax", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/fax/receive/{id}/assign`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportAssignFaxPayloadToJSON(requestParameters['supportAssignFaxPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Assigns the received fax
     * Assigns the received fax
     */
    async assignSupportReceiveFax(requestParameters: AssignSupportReceiveFaxRequest): Promise<ObjectNoResponse> {
        const response = await this.assignSupportReceiveFaxRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create and fax a document.
     * Create a fax
     */
    async createSupportSendFaxRaw(requestParameters: CreateSupportSendFaxRequest): Promise<runtime.ApiResponse<SupportSendFax>> {
        if (requestParameters['supportCreateFaxPayload'] === null || requestParameters['supportCreateFaxPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateFaxPayload','Required parameter requestParameters.supportCreateFaxPayload was null or undefined when calling createSupportSendFax.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:fax", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/fax/send`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateFaxPayloadToJSON(requestParameters['supportCreateFaxPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportSendFaxFromJSON(jsonValue));
    }

    /**
     * Create and fax a document.
     * Create a fax
     */
    async createSupportSendFax(requestParameters: CreateSupportSendFaxRequest): Promise<SupportSendFax> {
        const response = await this.createSupportSendFaxRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a receive fax
     * Get a receive fax
     */
    async getProviderReceiveFaxRaw(requestParameters: GetProviderReceiveFaxRequest): Promise<runtime.ApiResponse<ProviderReceiveFax>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderReceiveFax.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:fax"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/fax/receive/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderReceiveFaxFromJSON(jsonValue));
    }

    /**
     * Get a receive fax
     * Get a receive fax
     */
    async getProviderReceiveFax(requestParameters: GetProviderReceiveFaxRequest): Promise<ProviderReceiveFax> {
        const response = await this.getProviderReceiveFaxRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a send fax
     * Get a send fax
     */
    async getProviderSendFaxRaw(requestParameters: GetProviderSendFaxRequest): Promise<runtime.ApiResponse<ProviderSendFax>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderSendFax.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:fax"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/fax/send/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderSendFaxFromJSON(jsonValue));
    }

    /**
     * Get a send fax
     * Get a send fax
     */
    async getProviderSendFax(requestParameters: GetProviderSendFaxRequest): Promise<ProviderSendFax> {
        const response = await this.getProviderSendFaxRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a receive fax
     * Get a receive fax
     */
    async getSupportReceiveFaxRaw(requestParameters: GetSupportReceiveFaxRequest): Promise<runtime.ApiResponse<SupportReceiveFax>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportReceiveFax.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:fax", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/fax/receive/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportReceiveFaxFromJSON(jsonValue));
    }

    /**
     * Get a receive fax
     * Get a receive fax
     */
    async getSupportReceiveFax(requestParameters: GetSupportReceiveFaxRequest): Promise<SupportReceiveFax> {
        const response = await this.getSupportReceiveFaxRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a send fax
     * Get a send fax
     */
    async getSupportSendFaxRaw(requestParameters: GetSupportSendFaxRequest): Promise<runtime.ApiResponse<SupportSendFax>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportSendFax.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:fax", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/fax/send/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportSendFaxFromJSON(jsonValue));
    }

    /**
     * Get a send fax
     * Get a send fax
     */
    async getSupportSendFax(requestParameters: GetSupportSendFaxRequest): Promise<SupportSendFax> {
        const response = await this.getSupportSendFaxRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of receive faxes
     * Get a list of receive faxes
     */
    async listProviderReceiveFaxesRaw(requestParameters: ListProviderReceiveFaxesRequest): Promise<runtime.ApiResponse<Array<ProviderReceiveFax>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterDocumentId) {
            queryParameters['filterDocumentId'] = requestParameters.filterDocumentId;
        }

        if (requestParameters.filterExternalId) {
            queryParameters['filterExternalId'] = requestParameters.filterExternalId;
        }

        if (requestParameters.filterOcr) {
            queryParameters['filterOcr'] = requestParameters.filterOcr;
        }

        if (requestParameters.filterPages) {
            queryParameters['filterPages'] = requestParameters.filterPages;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:fax"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/fax/receive`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderReceiveFaxFromJSON));
    }

    /**
     * Gets a list of receive faxes
     * Get a list of receive faxes
     */
    async listProviderReceiveFaxes(requestParameters: ListProviderReceiveFaxesRequest): Promise<Array<ProviderReceiveFax>> {
        const response = await this.listProviderReceiveFaxesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of sent faxes
     * Get a list of sent faxes
     */
    async listProviderSendFaxesRaw(requestParameters: ListProviderSendFaxesRequest): Promise<runtime.ApiResponse<Array<ProviderSendFax>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterDocumentId) {
            queryParameters['filterDocumentId'] = requestParameters.filterDocumentId;
        }

        if (requestParameters.filterExternalId) {
            queryParameters['filterExternalId'] = requestParameters.filterExternalId;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:fax"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/fax/send`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderSendFaxFromJSON));
    }

    /**
     * Gets a list of sent faxes
     * Get a list of sent faxes
     */
    async listProviderSendFaxes(requestParameters: ListProviderSendFaxesRequest): Promise<Array<ProviderSendFax>> {
        const response = await this.listProviderSendFaxesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of receive faxes
     * Get a list of receive faxes
     */
    async listSupportReceiveFaxesRaw(requestParameters: ListSupportReceiveFaxesRequest): Promise<runtime.ApiResponse<Array<SupportReceiveFax>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterDocumentId) {
            queryParameters['filterDocumentId'] = requestParameters.filterDocumentId;
        }

        if (requestParameters.filterExternalId) {
            queryParameters['filterExternalId'] = requestParameters.filterExternalId;
        }

        if (requestParameters.filterAssigned) {
            queryParameters['filterAssigned'] = requestParameters.filterAssigned;
        }

        if (requestParameters.filterOcr) {
            queryParameters['filterOcr'] = requestParameters.filterOcr;
        }

        if (requestParameters.filterPages) {
            queryParameters['filterPages'] = requestParameters.filterPages;
        }

        if (requestParameters.filterTag) {
            queryParameters['filterTag'] = requestParameters.filterTag;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:fax", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/fax/receive`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportReceiveFaxFromJSON));
    }

    /**
     * Gets a list of receive faxes
     * Get a list of receive faxes
     */
    async listSupportReceiveFaxes(requestParameters: ListSupportReceiveFaxesRequest): Promise<Array<SupportReceiveFax>> {
        const response = await this.listSupportReceiveFaxesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of sent faxes
     * Get a list of sent faxes
     */
    async listSupportSendFaxesRaw(requestParameters: ListSupportSendFaxesRequest): Promise<runtime.ApiResponse<Array<SupportSendFax>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterDocumentId) {
            queryParameters['filterDocumentId'] = requestParameters.filterDocumentId;
        }

        if (requestParameters.filterExternalId) {
            queryParameters['filterExternalId'] = requestParameters.filterExternalId;
        }

        if (requestParameters.filterTag) {
            queryParameters['filterTag'] = requestParameters.filterTag;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:fax", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/fax/send`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportSendFaxFromJSON));
    }

    /**
     * Gets a list of sent faxes
     * Get a list of sent faxes
     */
    async listSupportSendFaxes(requestParameters: ListSupportSendFaxesRequest): Promise<Array<SupportSendFax>> {
        const response = await this.listSupportSendFaxesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Unassigns a fax piece from the user.
     * Unassigns the fax to the granted user
     */
    async unassignSupportReceiveFaxRaw(requestParameters: UnassignSupportReceiveFaxRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling unassignSupportReceiveFax.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["delete:fax", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/fax/receive/{id}/unassign`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Unassigns a fax piece from the user.
     * Unassigns the fax to the granted user
     */
    async unassignSupportReceiveFax(requestParameters: UnassignSupportReceiveFaxRequest): Promise<ObjectNoResponse> {
        const response = await this.unassignSupportReceiveFaxRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a fax\'s url
     * Get a fax\'s url
     */
    async viewProviderSendFaxRaw(requestParameters: ViewProviderSendFaxRequest): Promise<runtime.ApiResponse<TemporaryDocumentUrl>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling viewProviderSendFax.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:fax"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/fax/send/{id}/view`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TemporaryDocumentUrlFromJSON(jsonValue));
    }

    /**
     * Gets a fax\'s url
     * Get a fax\'s url
     */
    async viewProviderSendFax(requestParameters: ViewProviderSendFaxRequest): Promise<TemporaryDocumentUrl> {
        const response = await this.viewProviderSendFaxRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a fax\'s url
     * Get a fax\'s url
     */
    async viewSupportSendFaxRaw(requestParameters: ViewSupportSendFaxRequest): Promise<runtime.ApiResponse<TemporaryDocumentUrl>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling viewSupportSendFax.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:fax", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/fax/send/{id}/view`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TemporaryDocumentUrlFromJSON(jsonValue));
    }

    /**
     * Gets a fax\'s url
     * Get a fax\'s url
     */
    async viewSupportSendFax(requestParameters: ViewSupportSendFaxRequest): Promise<TemporaryDocumentUrl> {
        const response = await this.viewSupportSendFaxRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListProviderReceiveFaxesOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListProviderSendFaxesOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportReceiveFaxesOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportSendFaxesOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
